




















import Vue from "vue";

export default Vue.extend({
  name: "HelpPage",

  metaInfo() {
    return {
      title: "Help | ARPA Small Business - Greene County, MO",
    };
  },
});
